// features/drive/components/Upload/UploadButton.styles.js

import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const Button = styled.button`
  height: 40px;
  padding: 0 18px;

  border: none;
  border-radius: 8px;

  cursor: pointer;

  background: ${({ theme }) => theme.landing.buttonBg};
  color: white;
  font-weight: 500;

  transition: 0.2s;

  &:hover {
    background: ${({ theme }) => theme.landing.buttonHover};
  }
`;
